import axios from "axios";
import { SERVER_URL } from "Constants";

// DECLARE API RESPONSES
export type CustomerPaymentMethodDetails = {
	id: string;
	brand: string;
	lastFourDigits: string;
	billingEmail: string;
}
export type StripeSessionDetails = {
	sessionId: string,
	hasCompleted: boolean,
	clientSecret: string,
}

type CreateStripeSessionRequest = { sessionId: string, message: string }

// Query on single business payment
export async function getBusinessPaymentMethod(businessId: string) {
	const url = `${SERVER_URL}/api/stripe/business-entity-payment-method/${businessId}`;
	return await axios.get<CustomerPaymentMethodDetails | null>(url);
}

export async function deleteBusinessPaymentMethod(paymentMethodId: string) {
	const url = `${SERVER_URL}/api/stripe/payment-method/${paymentMethodId}`;
	return await axios.delete(url);
}

export const getStripeSessionDetail = async (sessionId: string) => {
	try {
		const response = await axios.get<StripeSessionDetails>(`${SERVER_URL}/api/stripe/session/${sessionId}`);
		return response.data;
	} catch (error) {
		console.error(error);
		return;
	}
}

export const fetchClientSecret = async (organisationId: string, businessEntityIds: string[], redirectUrl: string) => {
	const url = `${SERVER_URL}/api/stripe/create-checkout-session`;
	const body = {
		organisationId,
		businessEntityIds,
		redirectUrl,
	};
	const response = await axios.post<CreateStripeSessionRequest>(url, body);
	return response.headers['stripe-client-secret'] as string;
}